import React, { useState, useEffect } from "react";
import { ScalableImage, Typography } from "design_system/src";
import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { TSku } from "models/inventory/interfaces/sku.interface";
import { vehicleDetailData, VehicleDetailImage } from "models/inventory/interfaces/vehicle-detail.interfaces";
import { VehicleDetailImagesType } from "models/inventory/enums/vehicle-images.enums";
import styles from "./OutdoorPhotos.module.scss";

interface ExteriorPhotosProps {
  vehicle?: TVehicle;
  sku?: TSku;
  vehicleDetails?: vehicleDetailData;
}

const ExteriorPhotos: React.FC<ExteriorPhotosProps> = ({ vehicle, sku, vehicleDetails }) => {
  const [photos, setPhotos] = useState<VehicleDetailImage[]>([]);
  const imageType = [
    VehicleDetailImagesType.offRoadPhoto,
    VehicleDetailImagesType.urbanEnvironmentPhoto,
    VehicleDetailImagesType.withDriverPhoto,
    VehicleDetailImagesType.realEnvironmentParkedPhoto,
    VehicleDetailImagesType.motionDetailPhoto,
  ];

  useEffect(() => {
    if ((vehicle || sku) && vehicleDetails) {
      const data = !vehicle || vehicle?.isNewVehicle ? vehicleDetails?.images : vehicle?.detailsImages;
      setPhotos(data?.filter((img) => imageType.includes(img.imageType)).slice(0, 3) ?? []);
    }
  }, [vehicle, sku, vehicleDetails]);

  if (photos.length === 0) return <div/>;

  return (
    <>
      <Typography
        scale="large"
        weight="600"
        className="m_b_sm"
      >
        Así se ve la moto en acción
      </Typography>
      <div>
        {photos.map((item, idx: number) => {
          return (
            <div className="m_b_lg" key={`ExteriorPhotos-${idx}`}>
              <ScalableImage
                desktopWidth={50}
                mobileWidth={50}
                src={item.url}
                alt={item.name}
                className={`dso_card ${styles.ExteriorPhotosImage}`}
              />
              <Typography
                scale="xsmall"
                weight="400"
                className="text_right"
              >
                *Imagen de referencia
              </Typography>

              <Typography
                scale="medium"
                weight="400"
                className="m_t_sm"
              >
                {item.alternativeText}
              </Typography>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ExteriorPhotos;
